<template>
  <v-dialog v-model="dialogframe" persistent max-width="1000px">
    <template v-slot:activator="{ props }">
      <v-icon
        color="cyan"
        size="small"
        dark
        class="mb-2"
        v-bind="props"
        @click="CargueCombo"
      >
        mdi-filter-menu
      </v-icon>
    </template>
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>mdi-filter-menu</v-icon> Filtros
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn class="d-none d-md-block" dark text @click="reset"
            >Limpiar</v-btn
          >
          <v-btn class="d-none d-md-block" dark text @click="ValidateCampos"
            >Consultar</v-btn
          >
          <v-btn
            class="d-none d-md-block"
            dark
            text
            @click="dialogframe = false"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" autocomplete="off">
          <v-row v-for="(datos, i) in modelfiltro" :key="i">
            <!-- Filtro -->
            <v-col cols="6">
              <v-autocomplete
                v-model="datos.filtro"
                :items="items"
                item-title="descripcion"
                item-value="filtro"
                label="Tipo de filtro:"
                :clearable="datos.clear"
                :readonly="datos.lectura"
              ></v-autocomplete>
            </v-col>
            <!-- Contenido -->
            <v-col cols="6">
              <v-text-field
                v-model="datos.contenido"
                :label="datos.label"
                :type="
                  i == 2 || i == 4 ? 'date' : i == 3 || i == 5 ? 'time' : ''
                "
                :clearable="datos.clear"
                :readonly="datos.lectura"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
  <vue-advanced-chat
    :height="screenHeight"
    :current-user-id="currentUserId"
    :rooms="JSON.stringify(rooms)"
    :messages="JSON.stringify(messages)"
    :messages-loaded="messagesLoaded"
    :theme="theme"
    :rooms-loaded="true"
    :show-files="true"
    @send-message="sendMessage($event.detail[0])"
    @fetch-messages="onFetchMessages"
    @open-file="openFile($event.detail[0])"
    @upload-file="handleFileUpload($event.detail[0])"
  />
  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { register } from "vue-advanced-chat";
register();
var isDark = "";
export default {
  name: "Trazabilidad",
  props: {
    infollaves: {
      type: Object,
      default: [],
      Description: "Información de llaves",
    },
    NumeroSolicitud: {
      type: Number,
      default: 0,
      Description: "Numero de Solicitud",
    },
    infopermisos: {
      type: String,
      default: "0111",
      Description: "Información de permisos",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    SistemaOrigen: {
      type: Number,
      default: 1,
      Description: "Permisos equivalentes al usuario",
    },
  },
  data() {
    return {
      progreso: false,
      dialogframe: false,
      messagesLoaded: false,
      currentUserId: "1",
      theme: "",
      rooms: [
        {
          roomId: "1",
          roomName: "TCI Software",
          avatar: "/static/iconos/logofinaltcisoftware.svg",
          index: 2,
          users: [
            {
              _id: 1234,
              username: "TCI Software 1",
              avatar: "/static/iconos/logofinaltcisoftware.svg",
              status: {
                state: "offline",
                lastChanged: "today, 14:30",
              },
            },
            {
              _id: 12345,
              username: "TCI Software 2",
              avatar: "/static/iconos/logofinaltcisoftware.svg",
              status: {
                state: "offline",
                lastChanged: "14 July, 20:00",
              },
            },
            {
              _id: 12346,
              username: "TCI Software 3",
              avatar: "/static/iconos/logofinaltcisoftware.svg",
              status: {
                state: "offline",
                lastChanged: "14 July, 20:00",
              },
            },
          ],
          typingUsers: [1234, 1234],
        },
      ],
      messages: [],
      roomActions: [],
      modelfiltro: [
        {
          campo: "TextoMensaje",
          label: "Mensaje:",
          filtro: null,
          contenido: null,
        },
        {
          campo: "SistemaOrigen",
          label: "Sistema Origen:",
          filtro: null,
          contenido: null,
        },
        {
          campo: "FechaOrigino",
          label: "Fecha Inicio:",
          filtro: null,
          contenido: null,
        },
        {
          campo: "HoraOrigino",
          label: "Hora Inicio:",
          filtro: null,
          contenido: null,
        },
        {
          campo: "FechaOrigino",
          label: "Fechas Hasta:",
          filtro: null,
          contenido: null,
        },
        {
          campo: "HoraOrigino",
          label: "Hora Hasta:",
          filtro: null,
          contenido: null,
        },
        {
          campo: "TipoComunicacion",
          label: "Tipo de comunicación:",
          filtro: null,
          contenido: null,
        },
        {
          campo: "Usuario",
          label: "Emisor:",
          filtro: null,
          contenido: null,
        },
        {
          campo: "Solicitud",
          label: "Solicitud:",
          filtro: null,
          contenido: null,
        },
        {
          campo: "DocumentID",
          label: "Identificación",
          filtro: null,
          contenido: null,
        },
        {
          campo: "ContratoID",
          label: "Contrato:",
          filtro: null,
          contenido: null,
        },
        {
          campo: "Ref1",
          label: "Activo:",
          filtro: null,
          contenido: null,
        },
        {
          campo: "ServicioID",
          label: "Servicio:",
          filtro: null,
          contenido: null,
        },
      ],
      items: [
        {
          filtro: "=",
          descripcion: "Igual a",
        },
        {
          filtro: "LIKE",
          descripcion: "Similar a",
        },
        {
          filtro: ">=",
          descripcion: "Mayor igual a",
        },
        {
          filtro: "<=",
          descripcion: "Menor igual a",
        },
      ],
      busquedacompleta: false,
    };
  },

  methods: {
    onFetchMessages() {
      setTimeout(() => {
        this.messages = [];
        this.messagesLoaded = true;
      });
    },

    // Cargar los archivos
    handleFileUpload({ file, roomId }) {
      // Aquí puedes hacer la llamada a tu API para subir el archivo
      console.log("Archivo recibido:", file);

      // Ejemplo: enviar a tu backend .NET
      const formData = new FormData();
      formData.append("file", file);
    },

    //Abrir o descargar un archivo
    openFile({ file }) {
      console.log(file);
      this.progreso = true;
      // Consult Archivo
      this.axios
        .get(
          "/archivosdocumentos/ArchivoEspecifico?rutaComplementaria=" +
            file.file.url +
            "&nombreArchivo=" +
            file.file.name
        )
        .then((response) => {
          // Crear un enlace de descarga para descargar el archivo
          const link = document.createElement("a");
          link.href = `${file.file.preview}${response.data}`;
          link.download = file.file.name; // El nombre del archivo con la extensión
          console.log(link);
          link.click(); // Dispara la descarga
        })
        .catch((e) => console.log(e))
        .finally(() => {
          this.progreso = false;
        });
    },

    //Enviar Registro a base de datos y registrar
    async sendMessage({ content, roomId, files, replyMessage }) {
      this.progreso = true;
      var ReplicarMensaje = 0;
      var typedocument =
        this.infollaves != [] ? parseInt(this.infollaves.TypeDocument_ID) : 0;
      var documento = this.infollaves != [] ? this.infollaves.Document_ID : "";
      var contratoid = this.infollaves != [] ? this.infollaves.Contrato : "";
      var refactivo = this.infollaves != [] ? this.infollaves.Ref_1 : "";
      var servicioID =
        this.infollaves != [] && this.infollaves.IDServicio != null
          ? this.infollaves.IDServicio
          : 0;
      var polizaid = 0;
      var userperfil = this.$store.getters.userperfil;
      //Replicar Mensaje
      if (replyMessage != null) {
        ReplicarMensaje = replyMessage._id;
      }
      // Archivo
      let FileMensaje = null;
      let TypeFileMensaje = null;
      let NameFileMensaje = null;

      if (files != null && files.length > 0) {
        const file = new File([files[0].blob], files[0].name, {
          type: files[0].type,
        });
        console.log("file", file);

        const buffer = await files[0].blob.arrayBuffer();
        const bytes = Array.from(new Uint8Array(buffer));

        console.log("bytes", bytes);
        FileMensaje = bytes;
        TypeFileMensaje = files[0].type; // Tipo de archivo
        NameFileMensaje = files[0].name; // Nombre del archivo
      }

      // Data
      var data = {
        TipoComunicacion: 1,
        IdComunicacionOrigen: ReplicarMensaje,
        GrupoComunicacion: 0,
        SistemaOrigen: this.SistemaOrigen,
        TypeDocumentID: typedocument,
        DocumentID: documento,
        ContratoID: contratoid,
        Ref1: refactivo,
        ServicioID: servicioID,
        Solicitud: this.NumeroSolicitud,
        IDPoliza: polizaid,
        TextoMensaje: content,
        Emoji: "",
        TipoReceptor: 0,
        TypeDocumentIDEPSC: 0,
        DocumentIDEPSC: "",
        Grabacion: "",
        Legalizar: "",
        UsuarioLogin: userperfil.userInfo.Usuario_ID,
        NombreArchivo: NameFileMensaje,
        TipoArchivo: TypeFileMensaje,
        ArchivoBytes: FileMensaje,
      };
      console.log("data", data);
      this.axios
        .post("/personas/Id_ComunicacionTrazabilidad/CR0/", data)
        .then((response) => {
          var infoMessage = response.data;

          var messageanswer = {
            _id: infoMessage.IdComunicacion,
            indexId: 12224,
            sender_id: infoMessage.UsuarioOrigino,
            content: content,
            username: infoMessage.NombreUsuarioOrigino,
            avatar: "/static/iconos/logofinaltcisoftware.svg",
            date: infoMessage.FechaOrigino,
            timestamp: infoMessage.HoraOrigino,
            system: false,
            saved: true,
            distributed: true,
            seen: true,
            deleted: false,
            disableActions: false,
            disableReactions: false,
            replyMessage: replyMessage,
            files: files,
          };
          this.messages.push(messageanswer);
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen datos para esta consulta.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      this.busquedacompleta = false;
      for (var i = 0; i < this.modelfiltro.length; i++) {
        if (
          (this.modelfiltro[i].filtro == "" ||
            this.modelfiltro[i].filtro == null) &&
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido == "" ||
            this.modelfiltro[i].contenido == null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido != "" ||
            this.modelfiltro[i].contenido != null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          this.busquedacompleta = true;
        }
      }
      // Consultas a Ejecutar
      if (!validate) {
        this.ConsultMessage();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
        });
      }
    },
    //Consultar Registro a base de datos
    async ConsultMessage() {
      this.progreso = true;
      this.messages = [];
      if (this.NumeroSolicitud > 0) {
        this.busquedacompleta = true;
        this.modelfiltro[8].filtro = "=";
        this.modelfiltro[8].contenido = this.NumeroSolicitud.toString();
      }
      var data = {
        filtrado: this.modelfiltro,
        busquedacompleta: this.busquedacompleta,
      };
      try {
        this.axios
          .post("/personas/Id_ComunicacionTrazabilidad/CT0", data)
          .then((response) => {
            var infoMessage = response.data;
            for (var i = 0; i < infoMessage.length; i++) {
              this.messages.push(infoMessage[i].TextoMensaje);
            }
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.progreso = false;
            this.dialogframe = false;
          });
      } catch (error) {
        console.log(
          "Lo sentimos, ocurrió un error al intentar consultar los datos del proceso: " +
            error
        );
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.busquedacompleta = false;
      this.$refs.form.reset();
    },

    // Parametros Iframe
    parametrosiframe() {
      // Activo
      if (this.infollaves.Ref_1 != null && this.infollaves.Ref_1 != "") {
        this.modelfiltro[11].contenido = this.infollaves.Ref_1;
        this.modelfiltro[11].lectura = true;
        this.modelfiltro[11].clear = false;
        this.modelfiltro[11].filtro = "=";
      }
      console.log(this.infollaves);
      // ID Servicio
      if (
        this.infollaves.IDServicio != null &&
        this.infollaves.IDServicio != ""
      ) {
        this.modelfiltro[12].contenido = this.infollaves.IDServicio;
        this.modelfiltro[12].lectura = true;
        this.modelfiltro[12].clear = false;
        this.modelfiltro[12].filtro = "=";
      }

      // Contrato
      if (this.infollaves.Contrato != null && this.infollaves.Contrato != "") {
        this.modelfiltro[10].contenido = this.infollaves.Contrato;
        this.modelfiltro[10].lectura = true;
        this.modelfiltro[10].clear = false;
        this.modelfiltro[10].filtro = "=";
      }

      // Documento
      if (
        this.infollaves.Document_ID != null &&
        this.infollaves.Document_ID != ""
      ) {
        this.modelfiltro[9].contenido = this.infollaves.Document_ID;
        this.modelfiltro[9].lectura = true;
        this.modelfiltro[9].clear = false;
        this.modelfiltro[9].filtro = "=";
      }
      this.busquedacompleta = true;
      this.ConsultMessage();
    },
  },
  computed: {
    screenHeight() {
      return this.isDevice ? window.innerHeight + "px" : "calc(100vh - 80px)";
    },
  },
  mounted() {
    isDark = localStorage.getItem("isDark");
    this.theme = isDark == "1" ? "dark" : "light";
    console.log(this.pageiframe);
    // Se cargan los filtros por defecto
    if (!this.pageiframe) {
      this.ConsultMessage();
    } else {
      this.parametrosiframe();
    }
  },
};
</script>
